import { Config } from '@leverege/plugin';
const constants = () => ({
  manufactured: 'Manufactured',
  'in-transit': 'In Transit',
  available: 'Unpaired',
  paired: 'Paired',
  sold: 'Sold',
  'suspected-drive-off': 'Suspected Drive Off',
  'suspected-off-lot': 'Suspected Off Lot',
  'not-reporting': 'Not Reporting',
  'non-operational': 'Not Operational',
  'subscription-expired': 'Subscription Expired',
  stolen: 'Lost - Stolen',
  'sale-pending-remove': Config.get('PendingSaleMessage', 'label', 'Sale Pending, Unpair Locator'),
  'sale-pending-replace': 'Sale Pending, Replace Locator',
  'sale-pending': 'Sale Pending, Unpair Locator',
  'sold-low-battery': 'Sold with Low Battery',
  'sold-offline': 'Sold with Offline Locator',
  pendingAddLocator: 'Sale Pending, Add Locator',
  'not-applicable': 'N/A',
  'support-required': 'Lost - Support Required',
  'reconciliation-pending': 'Position Pending',
  converting: 'Converting',
  converted: 'Converted to Gateway',
  lost: 'Lost'
});
export default constants;